import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	container: {
		boxShadow       : `${ theme.other.colors.boxShadow.primary } !important`,
		borderRadius    : "1rem",
		backgroundColor : theme.other.colors.dialog.primary
	},
	contentContainer: {
		backgroundColor: theme.other.colors.dialog.secondary
	},
	listContainer: {
		padding: 0
	}
} ) );

